if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.productFormId = this.dataset.productFormId;
        this.sectionId = this.dataset.section;
        this.atcButton = this.querySelector('[data-sticky-atc]');
        this.buyButton = this.querySelector('[data-sticky-buy]');
        this.atcLabel = this.querySelector('[data-sticky-atc-label]');
        this.isVisible = false;

        this.onAtcClick = this.onAtcClick.bind(this);
        this.onBuyClick = this.onBuyClick.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);

        this.atcButton?.addEventListener('click', this.onAtcClick);
        this.buyButton?.addEventListener('click', this.onBuyClick);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);

        this.setupObserver();
      }

      disconnectedCallback() {
        this.atcButton?.removeEventListener('click', this.onAtcClick);
        this.buyButton?.removeEventListener('click', this.onBuyClick);
        this.variantChangeUnsubscriber?.();
        this.observer?.disconnect();
      }

      get productForm() {
        return document.getElementById(this.productFormId);
      }

      get mainSubmitButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      setupObserver() {
        const target =
          document.querySelector(`#ProductInfo-${this.sectionId} .product-form__buttons`) ||
          this.mainSubmitButton;

        if (!target) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.hide();
            } else {
              this.show();
            }
          },
          {
            root: null,
            threshold: 0,
            rootMargin: '0px 0px 0px 0px',
          }
        );

        this.observer.observe(target);
      }

      show() {
        if (this.isVisible) return;
        this.isVisible = true;
        this.classList.add('sticky-atc--visible');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sticky-atc-visible');
      }

      hide() {
        if (!this.isVisible) return;
        this.isVisible = false;
        this.classList.remove('sticky-atc--visible');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sticky-atc-visible');
      }

      onAtcClick() {
        const submitButton = this.mainSubmitButton;
        if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;
        submitButton.click();
      }

      onBuyClick() {
        const submitButton = this.mainSubmitButton;
        if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

        const paymentButton =
          this.productForm?.querySelector('.shopify-payment-button__button') ||
          document.querySelector(`#ProductInfo-${this.sectionId} .shopify-payment-button__button`);

        if (paymentButton && !paymentButton.disabled) {
          paymentButton.click();
          return;
        }

        const variantInput = this.productForm?.querySelector('[name="id"]');
        const quantityInput =
          document.querySelector(`#Quantity-${this.sectionId}`) ||
          this.productForm?.querySelector('[name="quantity"]');
        const variantId = variantInput?.value;
        const quantity = quantityInput?.value || 1;

        if (!variantId) return;
        const root = window.Shopify?.routes?.root || '/';
        window.location.href = `${root}cart/${variantId}:${quantity}`;
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const { html } = event.data;
        const sourcePrice = html?.getElementById(`StickyPrice-${this.sectionId}`);
        const destPrice = this.querySelector(`#StickyPrice-${this.sectionId}`);
        if (sourcePrice && destPrice) {
          destPrice.innerHTML = sourcePrice.innerHTML;
        } else {
          const mainPrice = document.getElementById(`price-${this.sectionId}`);
          if (mainPrice && destPrice) {
            destPrice.innerHTML = mainPrice.innerHTML;
          }
        }

        const sourceMedia = html?.getElementById(`StickyAtcMedia-${this.sectionId}`);
        const destMedia = this.querySelector(`#StickyAtcMedia-${this.sectionId}`);
        if (sourceMedia && destMedia) {
          destMedia.innerHTML = sourceMedia.innerHTML;
        }

        const submitButton = this.mainSubmitButton;
        const disabled = submitButton?.hasAttribute('disabled') ?? true;
        const label = disabled
          ? window.variantStrings?.soldOut || 'Sold out'
          : window.variantStrings?.addToCart || 'Add to cart';

        this.atcButton?.toggleAttribute('disabled', disabled);
        this.buyButton?.toggleAttribute('disabled', disabled);

        if (this.atcLabel) {
          this.atcLabel.textContent = label;
        }
      }
    }
  );
}
